<template>
  <section class="fa-table team-table py2 sans border-top mx-auto">
    <h3 class="sm-hide md-hide lg-hide mb3 red">Related Investigations</h3>
    <div class="row clearfix mxn2">
      <div class="col xs-hide md-col-4 px2">Related Investigations</div>
        <div class="col col-12 sm-col-8 px2">
          <div v-for="(item, index) in content"
            class="hover-red row clearfix mb2 mxn2" :key="index">
            <router-link
              :to="{ name: 'Investigation', params: { investigationSlug: item.slug }}">
              <div class="col col-6 relative px2">
                {{ item.title }}
              </div>
              <div class="col col-6 px2">
                <em>{{ item.location_title }}<br/>
                {{ incidentDates(item) }}</em>
              </div>
            </router-link>
          </div>
        </div>
    </div>
  </section>
</template>

<script>
import { incidentDates } from '@/utils.js'

export default {

  name: 'InvestigationsTable',

  data () {
    return {

    }
  },

  props: ['content'],

  methods: {
    incidentDates
  }
}
</script>

<style lang="css" scoped>
  .team-table {
    max-width: var(--max-width-med);
    /*font-size: var(--font-size-reader);*/
    line-height: var(--line-height-reader);
  }
  .badge {
    width: 64px;
    left: -96px;
    padding: 0 0.6em;
    border: 1px solid var(--black);
    text-align: center;
    border-radius: 8px;
    color: var(--black);

    &.red {
      color: var(--red);
      border-color: var(--red);
    }
  }
</style>
